import { createStateTag } from 'components/StateTag';
import type { InvoiceState } from './types';

export const InvoiceStateTag = createStateTag<InvoiceState>({
  testId: 'invoice-state-tag',
  stateVariantMap: {
    DRAFT: { icon: 'pen-to-square', variant: 'warning' },
    CONFIRMED: { icon: 'circle-check', variant: 'success' },
    CANCELED: { icon: 'circle-xmark', variant: 'secondary' },
  },
});
